import { render, staticRenderFns } from "./FleetReport.vue?vue&type=template&id=588652f2&scoped=true"
import script from "./FleetReport.vue?vue&type=script&lang=js"
export * from "./FleetReport.vue?vue&type=script&lang=js"
import style0 from "./FleetReport.vue?vue&type=style&index=0&id=588652f2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "588652f2",
  null
  
)

export default component.exports